module.exports = __webpack_public_path__ + "media/site/images/banners/banner-contact@2x-001956f5f1625e78c18d325ce98a06ab.png";